import { Directive, EventEmitter, inject, OnInit, Output } from '@angular/core';
import { RequiredDynamicItemBaseComponent } from '../dynamic-item';
import moment from 'moment';
import { IDynamicModelOptions } from '../../models/dynamic.interface';
import { LogService } from '@ups/xplat/core';

@Directive()
export abstract class DynamicTimeBaseComponent
  extends RequiredDynamicItemBaseComponent
  implements OnInit
{
  @Output() valueChange: EventEmitter<unknown> = new EventEmitter<unknown>();
  selectedTime: string;
  timeFormat = 'hh:mm a';
  apiTimeFormat = 'YYYY-MM-DDTHH-mmZZ';
  emptyDisplay = '---';
  log = inject(LogService);
  private pendingTimeUpdateTimeoutId: number | null = null;

  updateValue(value: string, targetFieldName?: string) {
    super.updateValue(value, targetFieldName);

    if (this.config?.options?.updateOnValueChange && this.dynamicService) {
      this.config?.options?.updateOnValueChange.forEach((selectionConfig) => {
        if (selectionConfig.formControlName) {
          const options: IDynamicModelOptions = {};
          // if (selectionConfig.validation === 'minDate') {
          //   options.minDate = this.getDateFromValue(value);
          // }
          this.dynamicService.itemTargetUpdate$.next({
            formControlName: selectionConfig.formControlName,
            value,
            type: 'time',
            options,
          });
        }
      });
    }
  }

  updateTimeValue(value: string | number | Date) {
    if (this.pendingTimeUpdateTimeoutId != null) {
      this.win.clearTimeout(this.pendingTimeUpdateTimeoutId);
    }

    this.pendingTimeUpdateTimeoutId = this.win.setTimeout(() => {
      this.pendingTimeUpdateTimeoutId = null;
      this.applyTimeValue(value);
    });
  }

  getTimeFromValue(value: string) {
    const time = value.split('T');
    const timeParts = time[1].split('-');
    const hr = timeParts[0];
    const min = timeParts[1];
    return moment()
      .startOf('day')
      .add(hr, 'hours')
      .add(min, 'minutes')
      .toDate();
  }

  private applyTimeValue(value: string | number | Date) {
    const datetime = moment(value);
    // if (this.config?.options?.minDate) {
    //   const minDate = moment(this.config?.options?.minDate);
    //   // console.log('datetime:', datetime);
    //   // console.log('minDate:', minDate);
    //   if (datetime.isBefore(minDate)) {
    //     this.dynamicService.win.alert({
    //       title: 'Invalid Date Selection',
    //       message: `${this.config.label} cannot be less than ${minDate.format(
    //         this.dateFormat
    //       )}`,
    //       okButtonText: 'Ok',
    //     });
    //     return;
    //   }
    // }

    this.selectedTime = datetime.format(this.timeFormat);

    const apiFormatValue = datetime.format(this.apiTimeFormat);

    this.updateValue(apiFormatValue);
    this.valueChange.emit(apiFormatValue);
    this.log.debug(apiFormatValue);
  }
}
